export const linkedinConfig = {
  name: 'LinkedIn',
  apiVersion: 'v2',
  requiredScopes: [
    'openid',
    'profile',
    'email'
  ].join(' '),
  authEndpoint: 'https://www.linkedin.com/oauth/v2/authorization',
  tokenEndpoint: 'https://www.linkedin.com/oauth/v2/accessToken',
  userinfoEndpoint: 'https://api.linkedin.com/v2/userinfo',
  
  settings: {
    name: {
      type: 'text',
      label: 'Connection Name',
      required: true
    }
  }
}; 